export default "__VITE_ASSET__5qC$qZSf__"